import React, { Fragment, useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import missions from '../../api/missions';
import './MissionDetailsPage.css';
import InstagramSection from '../../components/InstagramSection/InstagramSection';
import video1 from '../../videos/impact 1.mp4';
import video2 from '../../videos/impact-2.mp4';
import MissionImages from '../MissionImages/MissionImages.';
import MissionSliders from '../../components/MissionSliders/MissionSliders';

const MissionDetailsPage = () => {
  const { slug } = useParams();
  const [mission, setMission] = useState(null);

  useEffect(() => {
    const foundMission = missions.find(m => m.slug === slug);
    setMission(foundMission);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [slug]);

  if (!mission) {
    return (
      <Fragment>
        <Navbar Logo={Logo} hclass={'wpo-site-header-s5'} />
        {/* <PageTitle pageTitle={'Mission Not Found'} pagesub={'Mission'} /> */}
        <section className="error-section section-padding">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <div className="content clearfix">
                  <div className="error-message">
                    <h2>Mission not found</h2>
                    <p>The mission you're looking for doesn't exist.</p>
                    <Link to="/mission" className="theme-btn">Back to Missions</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={'wpo-site-header-s5'} />
      {/* <PageTitle pageTitle={mission.title} pagesub={'Mission Details'} /> */}

      {/* Hero Section */}
      <section className="mission-details-hero section-padding position-relative" style={{
        background: `#076897`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        repeat: 'no-repeat',
        color: 'white'
      }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="hero-content">
                <div className="year-badge mb-3">
                  <span className="badge bg-light text-dark fs-6 px-3 py-2">{mission.year} Mission</span>
                </div>
                <h1 className="display-4 fw-bold mb-3 text-white">{mission.title}</h1>
                <p className="lead mb-4 text-white" style={{ fontSize: '1.2rem', lineHeight: '1.6' }}>
                  {mission.description}
                </p>
                <div className="mission-meta d-flex flex-wrap gap-4 mb-4">
                  <div className="meta-item">
                    <i className="ti-location-pin me-2"></i>
                    <span>{mission.location}</span>
                  </div>
                  {/* <div className="meta-item">
                    <i className="ti-calendar me-2"></i>
                    <span>{mission.year}</span>
                  </div> */}
                  <div className="meta-item">
                    <i className="ti-time me-2"></i>
                    <span>{mission.stats.duration}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="stats-card bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 text-center">
                <h3 className="text-white mb-4">Mission Impact</h3>
                <div className="stats-grid">
                  <div className="stat-item">
                    <div className="stat-number display-6 fw-bold text-warning">{mission.stats.childrenTreated}+</div>
                    <div className="stat-label">Children Treated</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number display-6 fw-bold text-info">{mission.stats.volunteers}</div>
                    <div className="stat-label">Volunteers</div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section className="mission-content section-padding">
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-lg-7">
              <div className="overview-content">
                <h2 className="mb-4">Mission Overview</h2>
                <div className="content-text">
                  {mission.fullDescription.split('\n').map((paragraph, index) => (
                    paragraph.trim() ? <p key={index} className="mb-3">{paragraph.trim()}</p> : null
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={mission.image} alt={mission.title} className="img-fluid rounded-4 shadow-sm" />
            </div>
          </div>

          <div className="mission-highlights mb-5">
            <h3 className="mb-4">Key Highlights</h3>
            <div className="row g-4">
              {mission.highlights.map((highlight, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className="highlight-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div className="highlight-icon mb-3">
                      <i className={`ti-${index === 0 ? 'heart' : index === 1 ? 'user' : 'time'} fs-1 text-white`}></i>
                    </div>
                    <h5>{highlight}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="mission-gallery mb-5">
            <h3 className="mb-4">Mission Gallery</h3>
            <div className="row g-3">
              {mission.gallery.map((image, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className="gallery-item rounded-4 overflow-hidden shadow-sm">
                    <img src={image} alt={`Mission ${mission.title} ${index + 1}`} className="img-fluid" />
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </section>
  <div className="instagram-full-viewport">
      <MissionImages mission={mission} />
      </div>
    {
      mission.instagram && mission.instagram.length > 0 && (    
    <div className="instagram-full-viewport">
          <MissionSliders mission={mission} />
          </div>
  )  }
      

      {/* <section className="mission-videos section-padding">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <div className="video-card rounded-4 overflow-hidden shadow-sm">
                <video className="img-fluid w-100" controls >
                  <source src={video1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div className="video-caption p-4 bg-white">
                  <h5 className="mb-2">Mission Story</h5>
                  <p className="mb-0">A closer look at the mission journey and the people we helped.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="video-card rounded-4 overflow-hidden shadow-sm">
                <video className="img-fluid w-100" controls>
                  <source src={video2} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div className="video-caption p-4 bg-white">
                  <h5 className="mb-2">Medical Outreach</h5>
                  <p className="mb-0">Highlights from our training, surgery, and community outreach efforts.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="mission-team section-padding bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h3>Mission Team</h3>
            <p className="mb-0">Meet the experts and support staff who delivered this mission.</p>
          </div>
          <div className="row g-4">
            {mission.team.map((member, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="team-card bg-white p-4 rounded-4 shadow-sm text-center h-100">
                  <div className="team-avatar mb-3 d-inline-flex align-items-center justify-content-center text-white fw-bold" style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '50%',
                    background: '#667eea',
                    fontSize: '1.8rem'
                  }}>
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <h5 className="mb-1">{member.name}</h5>
                  <p className="text-muted mb-0">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default MissionDetailsPage;